import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {limitOptionsSelect} from "../helps/optionsSelect"
import {asyncCreator} from "./sliceHelper"
import {WSPSLeakDeviceIndication} from "../types/WebSocketTypes"
import {PSLeakDeviceIndicationResponse, PSLeakDeviceIndicationsResponse} from "../models/response"
import {psLeakDeviceIndicationApi} from "../api/psLeakDeviceIndicationApi"

export type PSLeakDeviceIndicationsFilter = {
    limit: number
    offset: number
} & PSLeakDeviceIndicationsFilterQuery

export type PSLeakDeviceIndicationsFilterQuery = {
    idCompany?: number
    idObjectGroup?: number
    idObject?: number
    idDevice?: number
    search?: string
}

type InitialStateType = {
    psLeakDeviceIndications: null | PSLeakDeviceIndicationsResponse
    psLeakDeviceIndication: null | PSLeakDeviceIndicationResponse
    filter: PSLeakDeviceIndicationsFilter
    ws: WSPSLeakDeviceIndication | null
}

const initialState: InitialStateType = {
    psLeakDeviceIndications: null,
    psLeakDeviceIndication: null,
    filter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    ws: null,
}

export const psLeakDeviceIndicationReducer = createSlice({
    name: "psLeakDeviceIndicationReducer",
    initialState,
    reducers: {
        setPSLeakDeviceIndications(state, {payload})
        {
            state.psLeakDeviceIndications = payload
        },
        setPSLeakDeviceIndication(state, {payload})
        {
            state.psLeakDeviceIndication = payload
        },
        setPSLeakDeviceIndicationsFilter(state, {payload})
        {
            state.filter = payload
        },
        setWSPSLeakDeviceIndication(state, {payload}: PayloadAction<WSPSLeakDeviceIndication | null>)
        {
            state.ws = payload
        },
    },
})

export const {setPSLeakDeviceIndicationsFilter, setPSLeakDeviceIndications, setPSLeakDeviceIndication, setWSPSLeakDeviceIndication} = psLeakDeviceIndicationReducer.actions

export default psLeakDeviceIndicationReducer.reducer

export const getPSLeakDeviceIndications = asyncCreator
("psLeakDeviceIndicationReducer/getPSLeakDeviceIndications", psLeakDeviceIndicationApi.getIndications, setPSLeakDeviceIndications)

export const getPSLeakDeviceIndication = asyncCreator
("psLeakDeviceIndicationReducer/getPSLeakDeviceIndication", psLeakDeviceIndicationApi.getIndication, setPSLeakDeviceIndication)

export const deletePSLeakDeviceIndications = asyncCreator
("psLeakDeviceIndicationReducer/deletePSLeakDeviceIndications", psLeakDeviceIndicationApi.deleteAll)

